export default __webpack_public_path__ + "static/media/error-bus.f251b6c7.svg";